import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Public.css';
import logo from './logo.png';

const NAV_LINKS = [
  { label: 'Home', to: '/' },
  // { label: 'Courses', href: '#courses' },
  // { label: 'Community', href: '#community' },
  { label: 'Events', href: '#events' },
  // { label: 'For Organisations', href: '#' },
  { label: 'About', href: '#' },
  // { label: 'Resources', href: '#' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const close = () => setOpen(false);

  return (
    <header className="pub-header">
      <div className="pub-topbar">
        <div className="pub-container pub-topbar-inner">
          <span className="pub-topbar-tagline">Empowering People &nbsp;·&nbsp; Accelerating Skills &nbsp;·&nbsp; Building the AI Future Together</span>
          <div className="pub-topbar-right">
            <span className="pub-topbar-lang">🌐 English</span>
            <Link to="/#help">Help</Link>
            <Link to="/#contact">Contact</Link>
            <div className="pub-topbar-social">
              <Link to="#" aria-label="LinkedIn">in</Link>
              <Link to="#" aria-label="YouTube">▶</Link>
              <Link to="#" aria-label="Facebook">f</Link>
              <Link to="#" aria-label="X">𝕏</Link>
            </div>
          </div>
        </div>
      </div>

      <nav className="pub-navbar">
        <div className="pub-container pub-nav-inner">
          <Link to="/" className="pub-logo" onClick={close}>
            <img src={logo} alt="AI World Community Logo" className="pub-logo-mark" />
            <span className="pub-logo-text">
              AI WORLD COMMUNITY
              <small>Learn · Connect · Build · Grow</small>
            </span>
          </Link>

          <button className="pub-nav-toggle" onClick={() => setOpen(o => !o)} aria-label="Menu">
            <span /><span /><span />
          </button>

          <div className={`pub-nav-links ${open ? 'open' : ''}`}>
            {NAV_LINKS.map(link => (
              link.to ? (
                <Link key={link.label} to={link.to} className={pathname === link.to ? 'active' : ''} onClick={close}>
                  {link.label}
                </Link>
              ) : (
                <a key={link.label} href={link.href} onClick={close}>{link.label}</a>
              )
            ))}
            <div className="pub-nav-actions">
              <button className="pub-nav-search" aria-label="Search">🔍</button>
              <a href="#events" className="pub-btn pub-btn-primary pub-btn-sm" onClick={close}>Join AIWC Free →</a>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}
